export const AutoEnablePlugins = Symbol.for('AutoEnablePlugins');
export const PluginService = Symbol.for('PluginService');
